import { useTranslation } from 'react-i18next';
import Image2 from '#app/assets/images/image2.jpg';
import Image3 from '#app/assets/images/image3.jpg';
import Image4 from '#app/assets/images/image4.jpg';
import Illustration from '#app/assets/images/page-illustration.svg';
import Image1 from '#app/assets/images/us.jpg';
import PostItem from '#app/components/post-item.tsx';
import Footer from '#app/components/ui/footer.tsx';
import Header from '#app/components/ui/header.tsx';

export default function About() {
	const { t } = useTranslation();

	return (
		<>
			<Header />

			<main className="grow">
				<>
					{/* Content */}
					<section className="relative">
						{/* Radial gradient */}
						<div
							className="pointer-events-none absolute left-1/2 top-0 -z-10 flex aspect-square w-[800px] -translate-x-1/2 -translate-y-1/2 items-center justify-center"
							aria-hidden="true"
						>
							<div className="translate-z-0 absolute inset-0 rounded-full bg-teal-500 opacity-30 blur-[120px]"></div>
							<div className="translate-z-0 absolute h-64 w-64 rounded-full bg-teal-400 opacity-70 blur-[80px]"></div>
						</div>

						{/* Particles animation */}
						<div className="absolute inset-0 -z-10 h-96" aria-hidden="true">
							<canvas
								data-particle-animation
								data-particle-quantity="15"
							></canvas>
						</div>

						{/* Illustration */}
						<div
							className="pointer-events-none absolute left-1/2 -z-10 -mt-16 -translate-x-1/2 opacity-90 blur-2xl md:block"
							aria-hidden="true"
						>
							<img
								src={Illustration}
								className="max-w-none"
								width={1440}
								height={427}
								alt="Page Illustration"
							/>
						</div>

						<div className="mx-auto max-w-6xl px-4 sm:px-6">
							<div className="pb-12 pt-32 md:pb-20 md:pt-40">
								{/* Page header */}
								<div className="pb-12 text-center md:pb-20">
									<h1 className="h1 bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-4 text-transparent">
										{t('roadmap.title')}
									</h1>
									<div className="mx-auto max-w-3xl">
										<p className="text-lg text-slate-400">
											{t('roadmap.subtitle')}
										</p>
									</div>
								</div>

								{/* Content */}
								<div className="mx-auto max-w-3xl">
									<div className="relative">
										<div
											className="absolute left-[2px] top-4 -z-10 h-full w-0.5 overflow-hidden bg-slate-800 [mask-image:_linear-gradient(0deg,transparent,theme(colors.white)_150px,theme(colors.white))] after:absolute after:left-0 after:top-0 after:h-4 after:w-0.5 after:-translate-y-full after:animate-shine after:bg-[linear-gradient(180deg,_transparent,_theme(colors.teal.500/.65)_25%,_theme(colors.teal.200)_50%,_theme(colors.teal.500/.65)_75%,_transparent)]"
											aria-hidden="true"
										></div>
										<PostItem
											metadata={{
												publishedAt: t(
													'roadmap.postItem.internalLaunch.publishedAt',
												),
												title: t('roadmap.postItem.internalLaunch.title'),
												image: Image1,
												description: t(
													'roadmap.postItem.internalLaunch.description',
												),
											}}
										/>

										<PostItem
											metadata={{
												publishedAt: t(
													'roadmap.postItem.publicLaunch.publishedAt',
												),
												title: t('roadmap.postItem.publicLaunch.title'),
												image: Image3,
												description: t(
													'roadmap.postItem.publicLaunch.description',
												),
											}}
										/>

										<PostItem
											metadata={{
												publishedAt: t(
													'roadmap.postItem.newFeatures.publishedAt',
												),
												title: t('roadmap.postItem.newFeatures.title'),
												image: Image4,
												description: t(
													'roadmap.postItem.newFeatures.description',
												),
											}}
										/>

										<PostItem
											metadata={{
												publishedAt: t(
													'roadmap.postItem.researchDevelopment.publishedAt',
												),
												title: t('roadmap.postItem.researchDevelopment.title'),
												image: Image2,
												description: t(
													'roadmap.postItem.researchDevelopment.description',
												),
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					</section>
				</>
			</main>

			<Footer />
		</>
	);
}
